import { EntityData } from '@/components/TriggerSetup/logic/types/entity-data.type'
import { baseCondition } from '@/components/TriggerSetup/logic/structures/base-condition.structure'
import { TriggerCondition } from '@/components/TriggerSetup/logic/types/types'
import { snakeCase } from 'lodash'
import MyRightsSetupView from './MyRightsSetupView.vue'
import { getTagsByFieldKey } from '@/mixins/TariffsTagsHelper'
import i18n from '@/i18n/i18n'

const condition: () => EntityData = () => {
    return {
        'setupView': MyRightsSetupView,
        'structure': {
            'type': 'MyRights',
            ...baseCondition,
            ...{ 'value': [ 'User' ] }
        } as TriggerCondition,
        'titleKey': `trigger_condition_${ snakeCase('MyRights') }`,
        'limited': getTagsByFieldKey('MyRightsCondition'),
    }
}

export default condition
